import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'
import Slider from "react-slick"

const propTypes = {
  slice: PropTypes.object,
  linkResolver: PropTypes.func
}

class HeroSection extends Component {
  render() {
    let { 
      slice,
      linkResolver
    } = this.props
    const settings = {
      dots: true,
      arrows: false,
      slidesToShow: 1, 
      slidesToScroll: 1,
    }
    const sp = slice.primary
    // console.log(slice)

    return (
      <section className="section-hero">
        {/* <div className="section-hero-banner" style={{backgroundImage: `url(${sp.banner_image.url})`}}>
          <div className="container">
            {PrismicReact.RichText.render(sp.banner_image_title)}
            {PrismicReact.RichText.render(sp.banner_image_subtitle)}
          </div>
        </div> */}
        <Slider className="hero-slider" {...settings}>
          {
            slice.items.map((item, index) => 
              <div key={index} className={`slider-item slider-item-${index}`}>
                <div 
                  className="section-hero-banner" 
                  style={{backgroundImage: `url(${item.item_image.url})`}}
                >
                  <div className="container">
                    {item.item_title && PrismicReact.RichText.render(item.item_title)}
                    <div className={`subtitle ${item.subtitle_position}`}>
                      {item.item_subtitle && PrismicReact.RichText.render(item.item_subtitle)}
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </Slider>
        <div className="section-hero-content">
          <div className="container container-medium">
            {PrismicReact.RichText.render(sp.description)}
            {/* <div className="award-group">
              <img src={sp.award_icon.url} alt={PrismicReact.RichText.asText(sp.award_description)}/>
              {PrismicReact.RichText.render(sp.award_description)}
            </div> */}
            <Link to={PrismicReact.Link.url(sp.cta_link, linkResolver)} className="button button-large">{sp.cta_link_name}</Link>
          </div>
        </div>
      </section>
    )
  }
}

HeroSection.propTypes = propTypes

export default HeroSection


// WEBPACK FOOTER //
// ./src/components/Home/HeroSection.js